/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionMetadataErrorDetails } from './PalAuthSubmissionMetadataErrorDetails';
import {
    PalAuthSubmissionMetadataErrorDetailsFromJSON,
    PalAuthSubmissionMetadataErrorDetailsFromJSONTyped,
    PalAuthSubmissionMetadataErrorDetailsToJSON,
} from './PalAuthSubmissionMetadataErrorDetails';

/**
 * 
 * @export
 * @interface PalAuthSubmissionMetadata
 */
export interface PalAuthSubmissionMetadata {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionMetadata
     */
    remote_dashboard_id?: string;
    /**
     * 
     * @type {PalAuthSubmissionMetadataErrorDetails}
     * @memberof PalAuthSubmissionMetadata
     */
    error_details?: PalAuthSubmissionMetadataErrorDetails;
    /**
     * Verbatim payer name read off the Availity routing page (e.g. "PREMERA BLUECROSS (WA)") on a routed failure. The display value for which payer the patient was routed to. Present for both PAYOR_ROUTED_TO_DIFFERENT_PAYOR and PAYOR_ROUTED_TO_DIFFERENT_PAYOR_WITH_RPA; the error_type signals whether an automatic switch/retry is available.
     * @type {string}
     * @memberof PalAuthSubmissionMetadata
     */
    changed_payer_target_raw_name?: string;
    /**
     * Normalized destination fax number used for eFax submissions.
     * @type {string}
     * @memberof PalAuthSubmissionMetadata
     */
    destination_fax_number?: string;
    /**
     * Normalized fax number the eFax was sent from. Null when sent from the shared/generic exacare fax number rather than a dedicated eFax inbox number.
     * @type {string}
     * @memberof PalAuthSubmissionMetadata
     */
    sender_fax_number?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionMetadata interface.
 */
export function instanceOfPalAuthSubmissionMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionMetadataFromJSON(json: any): PalAuthSubmissionMetadata {
    return PalAuthSubmissionMetadataFromJSONTyped(json, false);
}

export function PalAuthSubmissionMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'remote_dashboard_id': !exists(json, 'remote_dashboard_id') ? undefined : json['remote_dashboard_id'],
        'error_details': !exists(json, 'error_details') ? undefined : PalAuthSubmissionMetadataErrorDetailsFromJSON(json['error_details']),
        'changed_payer_target_raw_name': !exists(json, 'changed_payer_target_raw_name') ? undefined : json['changed_payer_target_raw_name'],
        'destination_fax_number': !exists(json, 'destination_fax_number') ? undefined : json['destination_fax_number'],
        'sender_fax_number': !exists(json, 'sender_fax_number') ? undefined : json['sender_fax_number'],
    };
}

export function PalAuthSubmissionMetadataToJSON(value?: PalAuthSubmissionMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'remote_dashboard_id': value.remote_dashboard_id,
        'error_details': PalAuthSubmissionMetadataErrorDetailsToJSON(value.error_details),
        'changed_payer_target_raw_name': value.changed_payer_target_raw_name,
        'destination_fax_number': value.destination_fax_number,
        'sender_fax_number': value.sender_fax_number,
    };
}

